/**
 * Coming-soon checkout guard (OACE-491c).
 *
 * Preview products stay purchasable during their countdown, but checkout is blocked while
 * the cart holds a line whose preview window has not ended. The cart sections render that
 * state server-side; this guard re-checks it against the client clock at click time, so the
 * block lifts exactly at the end time even in a cart drawer that has been open for a while.
 *
 * Listeners are delegated from the document: the cart drawer replaces its footer markup on
 * every cart change, so anything bound directly to the checkout button would be detached.
 *
 * This is the storefront affordance only. The authoritative gate is the cart-validation
 * function in the OACE app, which also covers express buttons and direct checkout links.
 */
(function () {
  'use strict';

  // Both cart sections load this file and the drawer renders on every page, so on /cart the
  // script is injected twice — register the document listeners only once.
  if (window.comingSoonCartGuardLoaded) {
    return;
  }
  window.comingSoonCartGuardLoaded = true;

  var BLOCK_SELECTOR = '[data-coming-soon-block]';

  function hasActivePreviewLine() {
    var lines = document.querySelectorAll('[data-coming-soon-end]');
    var now = Date.now();

    for (var i = 0; i < lines.length; i++) {
      var endsAt = parseInt(lines[i].getAttribute('data-coming-soon-end'), 10);

      if (!isNaN(endsAt) && endsAt * 1000 > now) {
        return true;
      }
    }

    return false;
  }

  function release(button) {
    button.removeAttribute('data-coming-soon-block');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-describedby');
  }

  function showError(button) {
    var errorId = button.getAttribute('aria-describedby');
    var error = errorId ? document.getElementById(errorId) : null;

    if (!error) {
      return;
    }

    error.removeAttribute('hidden');
    error.focus();
  }

  function block(event, button) {
    event.preventDefault();
    event.stopPropagation();
    showError(button);
  }

  function onClick(event) {
    var button = event.target.closest && event.target.closest(BLOCK_SELECTOR);

    if (!button) {
      return;
    }

    if (hasActivePreviewLine()) {
      block(event, button);
    } else {
      release(button);
    }
  }

  function onSubmit(event) {
    var button = event.target.querySelector && event.target.querySelector(BLOCK_SELECTOR);

    if (!button) {
      return;
    }

    if (hasActivePreviewLine()) {
      block(event, button);
    } else {
      release(button);
    }
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);
})();
